import { Avatar, Button, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField, Tooltip, Typography } from '@material-ui/core';
import { KeyboardArrowRight } from '@material-ui/icons';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { formatCurrency, track } from '../../libs/helpers';

class FundraiseSeedAmount extends React.Component {

  state = {

  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  onDonorCoverFees = async () => {
    track(
      this.props.trackPageCode,
      'Donor Cover Fees ' + (!this.props.form.donorCoverFees ? 'Checked' : 'Not Checked'));
    this.props.onChange('donorCoverFees', !this.props.form.donorCoverFees, true);
  }
  amountButtonClicked = (amount) => {
    return () => {
      track(
        this.props.trackPageCode,
        'Amount Button Clicked', amount
      );
      this.props.onChange({ 'buttonAmount': amount, amount: '' }, true);
    }
  }
  /* Render Page */
  render() {
    const { form, classes, fundraise } = this.props;
    let { onDonorCoverFees } = this;
    return (
      <div >
        <Grid container direction="row" justify="space-between">
          <Grid item container alignContent="center" style={{ width: "auto" }}>
            <Typography className={classes.studentName} >
              Donate to {fundraise.name}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar} >
              <img alt={fundraise.name} style={{ width: '100%' }} src={fundraise.image_url} />
            </Avatar>
          </Grid>
        </Grid>
        <Grid container spacing={3} className={classes.amountButtonsCont} >
          <Grid item xs={4}>
            <Button fullWidth className={[classes.amountButton, form.buttonAmount === 25 && classes.amountButtonSelected]}
              onClick={this.amountButtonClicked(25)}
              color={'default'}
              variant={'outlined'}
            >$25</Button>
          </Grid>
          <Grid item xs={4}>
            <Button fullWidth className={[classes.amountButton, form.buttonAmount === 50 && classes.amountButtonSelected]}
              onClick={this.amountButtonClicked(50)}
              variant={'outlined'}
            >$50</Button>
          </Grid>
          <Grid item xs={4}>
            <Button fullWidth className={[classes.amountButton, form.buttonAmount === 100 && classes.amountButtonSelected]}
              onClick={this.amountButtonClicked(100)}
              variant={'outlined'}
            >$100</Button>
          </Grid>
          <Grid item xs={4}>
            <Button fullWidth className={[classes.amountButton, form.buttonAmount === 500 && classes.amountButtonSelected]}
              variant={'outlined'}
              onClick={this.amountButtonClicked(500)}
              style={{ marginTop: 0 }}>$500</Button>
          </Grid>
          <Grid item xs={8}>
            <TextField
              id="outlined-name"
              label="Other amount"
              value={form.amount || ''}
              margin="none"
              variant="outlined"
              type='number'
              className={classes.amountOther}
              fullWidth
              onChange={(e) => this.props.onChange({ 'amount': e.target.value, 'buttonAmount': '' }, true)}
              InputProps={{
                classes: {
                  root: classes.amountOtherRoot,
                  input: classes.amountOtherInput,
                  notchedOutline: classes.amountOtherNotchedOutline,
                },
                //  className: ['padding-input', classes.amountOtherInput]
              }}
              InputLabelProps={{ className: ['lg', classes.amountOtherLabel] }}

              onBlur={this.props.onFieldBlur('Amount')}
            />          </Grid>
        </Grid>

        <div className={classes.coverProcessingFees}>
          <FormControlLabel
            className='bmargin-sm'
            control={
              <Checkbox
                checked={form.donorCoverFees}
                value="1"
                name='donorCoverFees'
                color="#A0A1B0"
                className={'tbpadding-5'}
                onChange={onDonorCoverFees}
              />
            }
            label={<Typography className={classes.coverProcessingFeesText}>Cover processing fees, <a rel="noopener noreferrer" target="_blank" href="https://www.edseed.me/fees/">read more</a> </Typography>}
          />
        </div>
        <Typography onClick={(e) => this.props.onChange('dedicateMyDonation', !form.dedicateMyDonation)}>
          <KeyboardArrowRight className={classes.giveInHonorText}
            style={{ transform: form.dedicateMyDonation ? "rotate(90deg)" : "rotate(0deg)" }} />
          <Typography className={classes.giveInHonorText}>
            &nbsp;Give in honor of someone</Typography>
        </Typography>
        {
          form.dedicateMyDonation && <div style={{ padding: '0 7px' }}>
            <FormControl variant="outlined"
              margin="none"
              className={[classes.formControl, 'fullwidth', classes.dedicationFieldsWarper]}>
              <InputLabel
                htmlFor="inHonorOf"
              >
                Type
              </InputLabel>
              <Select

                value={form.inHonorOf}
                input={
                  <OutlinedInput
                    inputProps={{
                      className: 'padding-input',
                    }}
                    className={classes.dedicationFields}
                    labelWidth={150}
                    name="inHonorOf"
                    id="inHonorOf"
                    onChange={(e) => this.props.onChange('inHonorOf', e.target.value)}
                    onBlur={this.props.onFieldBlur('Dedication Type')}
                  />
                }
              >
                <MenuItem value={true}>In honor of...</MenuItem>
                <MenuItem value={false}>In memory of...</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="honoreeName"
              label="Honoree's Name"
              value={form.honoreetName}
              margin="none"
              className={classes.dedicationFieldsWarper}
              variant="outlined"

              onChange={(e) => this.props.onChange('honoreeName', e.target.value)}
              name='honoreeName'
              fullWidth
              inputProps={{ className: 'padding-input' }}
              InputProps={{ classes: { notchedOutline: classes.dedicationFields, } }}
              InputLabelProps={{ className: ['padding-label', classes.dedicationLabel] }}
              onBlur={this.props.onFieldBlur('Honoree Name')}
            />
            <TextField
              id="recipientEmail"
              label="Recipient Email"
              value={form.recipientEmail}
              margin="none"
              className={classes.dedicationFieldsWarper}
              variant="outlined"
              onChange={(e) => this.props.onChange('recipientEmail', e.target.value)}
              name='recipientEmail'
              fullWidth
              inputProps={{ className: 'padding-input' }}
              InputProps={{ classes: { notchedOutline: classes.dedicationFields, } }}
              InputLabelProps={{ className: ['padding-label', classes.dedicationLabel] }}
              onBlur={this.props.onFieldBlur('Recipient Email')}
            />
            <TextField
              id="recipientName"
              label="Recipient Name"
              value={form.recipientName}
              margin="none"
              className={classes.dedicationFieldsWarper}
              variant="outlined"
              onChange={(e) => this.props.onChange('recipientName', e.target.value)}
              name='recipientName'
              fullWidth
              inputProps={{ className: 'padding-input' }}
              InputProps={{ classes: { notchedOutline: classes.dedicationFields, } }}
              InputLabelProps={{ className: ['padding-label', classes.dedicationLabel] }}
              onBlur={this.props.onFieldBlur('Recipient Name')}
            />
            <FormControl variant="outlined" margin="normal"
              className={[classes.formControl, 'fullwidth', classes.dedicationFieldsWarper]}>
              <InputLabel
                htmlFor="recipientMessage"
              >
              </InputLabel>
              <Tooltip
                placement='top-end'
                title='Please spell check, include how you would like your name(s) signed, mention the amount if desired, and format your message as you would like it delivered.'>
                <TextField
                  id="recipientMessage"
                  label="Your Message to the Recipient"
                  value={form.recipientMessage}
                  margin="none"
                  variant="outlined"
                  onChange={(e) => this.props.onChange('recipientMessage', e.target.value)}
                  name='recipientMessage'
                  fullWidth
                  InputProps={{ classes: { notchedOutline: classes.dedicationFields, } }}
                  InputLabelProps={{ className: ['padding-label', classes.dedicationLabel] }}
                  onBlur={this.props.onFieldBlur('Recipient Message')}
                  multiline
                />
              </Tooltip>
            </FormControl>

          </div>
        }
        <Typography align="right" color="textSecondary" className={classes.totalAmountText}>
          Total Amount: <Typography className={classes.totalAmount} display="inline">${formatCurrency(form.processedAmount,2)}</Typography>
        </Typography>
        <Button fullWidth variant='contained' className={[classes.buttonAlt]} disabled="true">Back</Button>
        <Button fullWidth variant='contained' className={[classes.button]} onClick={this.props.onPanelExpanded('donorInformation')}>Next Step</Button>
      </div >
    );
  }
}

export default withRouter(FundraiseSeedAmount);